import { render, staticRenderFns } from "./MonthlyNewsletters.vue?vue&type=template&id=49c48b42&scoped=true&"
import script from "./MonthlyNewsletters.vue?vue&type=script&lang=js&"
export * from "./MonthlyNewsletters.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyNewsletters.vue?vue&type=style&index=0&id=49c48b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c48b42",
  null
  
)

export default component.exports